import err from './err';
import user from './user';
import sys from './sys';
import group from './group';
import worker from './worker';
import session from './session';
import contract from './contract';

const req = {
  err,
  user,
  sys,
  group,
  worker,
  session,
  contract,
};

export default req;
